import { type IMeshGeometry, type ISkeleton, MeshParser } from '@seddi/mesh';
import type { LoadingManager } from '@seddi/three';
import { load as loadFile } from '../loaders/binaryAssetLoader';

type AvatarGeometry = {
  geometry: IMeshGeometry;
  skeleton?: ISkeleton;
};

/**
 * Load avatar geometry.
 * @param url = Resource URL.
 * @param manager - Loading manager.
 */
export const load = async (url: string, manager: LoadingManager): Promise<AvatarGeometry> => {
  const bytes = await loadFile(url, manager);
  const data = MeshParser.Parse(bytes);
  return data;
};
